var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactivePayoutQuery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10C4.1448 10 7.67573 10.4875 11.0312 11.4008C11.5158 11.5327 12 11.1724 12 10.6701V10M1.5 0.5V1C1.5 1.27614 1.27614 1.5 1 1.5H0.5M0.5 1.5V1.25C0.5 0.835787 0.835786 0.5 1.25 0.5H12.5M0.5 1.5V7.5M12.5 0.5V1C12.5 1.27614 12.7239 1.5 13 1.5H13.5M12.5 0.5H12.75C13.1642 0.5 13.5 0.835787 13.5 1.25V7.75C13.5 8.16421 13.1642 8.5 12.75 8.5H12.5M13.5 7.5H13C12.7239 7.5 12.5 7.72386 12.5 8V8.5M12.5 8.5H1.5M1.5 8.5H1.25C0.835786 8.5 0.5 8.16421 0.5 7.75V7.5M1.5 8.5V8C1.5 7.72386 1.27614 7.5 1 7.5H0.5M9 4.5C9 5.60457 8.10457 6.5 7 6.5C5.89543 6.5 5 5.60457 5 4.5C5 3.39543 5.89543 2.5 7 2.5C8.10457 2.5 9 3.39543 9 4.5ZM11 4.5H11.005V4.505H11V4.5ZM3 4.5H3.005V4.505H3V4.5Z",
    stroke: "#1F1F1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivePayoutQuery);
export default __webpack_public_path__ + "static/media/deactive-payout-query.95856d6dffd18563a0ddb1f1445cddf4.svg";
export { ForwardRef as ReactComponent };